import { render } from "./AppTopbarMenu.vue?vue&type=template&id=6468ee1c"
import script from "./AppTopbarMenu.vue?vue&type=script&lang=js"
export * from "./AppTopbarMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rogeriolugaoveltem/Documents/mtex_nesher_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__